import axiosV1 from "@/plugins/axios/configV1";

export default {
    getProduct(id = null) {
        return axiosV1.get(`/products/fetch/${id}`);
    },
    getProducts(params) {
        return axiosV1.get(`products`, { params });
    },
    exportExcel(params) {
        return axiosV1.get(`products/export`, { params });
    },
    deleteProduct(id) {
        return axiosV1.post(`products/delete/${id}`);
    },
    deleteProductAll(ids) {
        return axiosV1.post(`products/bulk/delete`, ids);
    },
    recoverProduct(id) {
        return axiosV1.post(`products/recover/${id}`);
    },
    recoverProductAll(ids) {
        return axiosV1.post(`products/bulk/recover`, ids);
    },
    destroyProduct(id) {
        return axiosV1.post(`products/destroy/${id}`);
    },
    destroyProductAll(ids) {
        return axiosV1.post(`products/bulk/destroy`, ids);
    },
    getProductCategories() {
        return axiosV1.get("products/categories/all");
    },
    getProductSubCategories(id) {
        return axiosV1.get(`products/sub-categories?category_id=${id}`);
    },
    getProductSubCategoryAll() {
        return axiosV1.get("products/sub-categories");
    },
    getProductServicePackages() {
        return axiosV1.get("products/service-packages");
    },
    getProductNumbers(id = null, params) {
        return axiosV1.get(`products/fetch-serial-numbers/${id}`, { params });
    },
    getProductActivities(id = null, params) {
        return axiosV1.get(`products/fetch-activity-logs/${id}`, { params });
    },
    exportProductActivities(id = null, params) {
        return axiosV1.get(`products/export/activity-logs/${id}`, { params });
    },
    exportProductNumbers(id = null, params) {
        return axiosV1.get(`products/export/serial-numbers/${id}`, { params });
    },
    addProduct(params) {
        let formData = new FormData();
        axiosV1.defaults.headers.common["Content-Type"] = "multipart/form-data";

        for (const key in params) {
            if (["service_package", "photo", "serial_no_ids"].includes(key))
                break;
            formData.append(key, params[key] ? params[key] : "");
        }
        for (const photo of params.photo) {
            formData.append("photo[]", photo);
        }

        for (const key in params.service_package) {
            formData.append(
                `service_package[${key}][id][]`,
                params.service_package[key]["id"]
            );
            formData.append(
                `service_package[${key}][price][]`,
                params.service_package[key]["price"]
            );

            for (const covered_area_code of params.service_package[key][
                "covered_area_code"
            ]) {
                formData.append(
                    `service_package[${key}][covered_area_code][]`,
                    covered_area_code
                );
            }
            for (const covered_area_name of params.service_package[key][
                "covered_area_name"
            ]) {
                formData.append(
                    `service_package[${key}][covered_area_name][]`,
                    covered_area_name
                );
            }
        }

        // for (const value of params.serial_no_ids) {
        //     formData.append(`serial_numbers[]`, value.serial);
        // }
        formData.append("serial_number", JSON.stringify(params.serial_no_ids));

        return axiosV1.post(`products`, formData);
    },

    updateProduct(id = null, params = {}) {
        let formData = new FormData();
        axiosV1.defaults.headers.common["Content-Type"] = "multipart/form-data";

        for (const key in params) {
            if (["service_package", "photo", "serial_no_ids"].includes(key))
                break;
            formData.append(key, params[key] ? params[key] : "");
        }
        for (const photo of params.photo) {
            formData.append("photo[]", photo);
        }

        for (const key in params.service_package) {
            formData.append(
                `service_package[${key}][id][]`,
                params.service_package[key]["id"]
            );
            formData.append(
                `service_package[${key}][price][]`,
                params.service_package[key]["price"]
            );

            for (const covered_area_code of params.service_package[key][
                "covered_area_code"
            ]) {
                formData.append(
                    `service_package[${key}][covered_area_code][]`,
                    covered_area_code
                );
            }
            for (const covered_area_name of params.service_package[key][
                "covered_area_name"
            ]) {
                formData.append(
                    `service_package[${key}][covered_area_name][]`,
                    covered_area_name
                );
            }
        }

        // for (const value of params.serial_no_ids) {
        // //     formData.append(`serial_numbers[]`, value.serial);
        // }
        formData.append("serial_number", JSON.stringify(params.serial_no_ids));

        return axiosV1.post(`products/update/${id}`, formData);
    },
    viewProduct(id = null) {
        return axiosV1.get(`products/view/${id}`);
    },
    importProduct(file = null) {
        let formData = new FormData();
        formData.append("file", file);
        axiosV1.defaults.headers.common["Content-Type"] = "multipart/form-data";
        return axiosV1.post(`products/import`, formData);
    },
    importProductSerial(file = null) {
        let formData = new FormData();
        formData.append("file", file);
        axiosV1.defaults.headers.common["Content-Type"] = "multipart/form-data";
        return axiosV1.post(`products/serial-numbers/bulk/import`, formData);
    },
};
